import { render } from "./ExportPanel.vue?vue&type=template&id=1517bc51&scoped=true&ts=true"
import script from "./ExportPanel.vue?vue&type=script&lang=ts"
export * from "./ExportPanel.vue?vue&type=script&lang=ts"

import "./ExportPanel.vue?vue&type=style&index=0&id=1517bc51&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1517bc51"]])

export default __exports__